<template>
  <div>

    <!-- ══════════════════════════════════════════
         MODAL: NOVA VERSÃO
    ══════════════════════════════════════════ -->
    <transition name="uv-fade">
      <div v-if="showUpdateModal" class="uv-overlay" @click.self="closeUpdateModal">
        <div class="uv-card">

          <!-- Header -->
          <div class="uv-header">
            <div class="uv-header-left">
              <div class="uv-rocket">🚀</div>
              <div>
                <div class="uv-tag">Nova versão disponível</div>
                <h2 class="uv-title">VSLBooster foi atualizado!</h2>
              </div>
            </div>
            <button class="uv-close" @click="closeUpdateModal">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
              </svg>
            </button>
          </div>

          <!-- Novidades -->
          <div class="uv-body">
            <p class="uv-intro">Fizemos muitas melhorias e esperamos que você adore! Aqui está o que há de novo:</p>

            <div class="uv-changes">
              <div class="uv-change-item">
                <div class="uv-change-icon uv-change-icon--blue">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </div>
                <div><strong>Dashboard redesenhado</strong> — nova interface mais rápida e intuitiva</div>
              </div>
              <div class="uv-change-item">
                <div class="uv-change-icon uv-change-icon--green">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M22 11.08V12a10 10 0 11-5.93-9.14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M22 4L12 14.01l-3-3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </div>
                <div><strong>Analytics aprimorado</strong> — métricas de vídeo e chat em tempo real</div>
              </div>
              <div class="uv-change-item">
                <div class="uv-change-icon uv-change-icon--purple">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><path d="M12 8v4l3 3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                </div>
                <div><strong>Velocidade</strong> — backend unificado, resposta até 3× mais rápida</div>
              </div>
              <div class="uv-change-item">
                <div class="uv-change-icon uv-change-icon--orange">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </div>
                <div><strong>Player atualizado</strong> — novo player com suporte a autoplay e thumbnail</div>
              </div>
            </div>

            <!-- Alerta embed -->
            <div class="uv-alert">
              <div class="uv-alert-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="#E86A10" stroke-width="2"/>
                  <line x1="12" y1="9" x2="12" y2="13" stroke="#E86A10" stroke-width="2" stroke-linecap="round"/>
                  <line x1="12" y1="17" x2="12.01" y2="17" stroke="#E86A10" stroke-width="2.5" stroke-linecap="round"/>
                </svg>
              </div>
              <div class="uv-alert-text">
                <strong>Ação necessária: atualize o script de embed no seu site!</strong>
                <p>O código de embed foi atualizado. Acesse cada vídeo/chat e copie o novo script para colar no seu site.</p>
              </div>
            </div>

            <!-- Snippet rápido -->
            <div class="uv-snippet-wrap">
              <div class="uv-snippet-label">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><polyline points="16 18 22 12 16 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><polyline points="8 6 2 12 8 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                Onde encontrar seu novo script:
              </div>
              <div class="uv-snippet-steps">
                <span class="uv-step">1. Vá em <strong>Meus Vídeos</strong></span>
                <span class="uv-step-arrow">→</span>
                <span class="uv-step">2. Clique no botão <span class="uv-code-btn-badge"><svg width="11" height="11" viewBox="0 0 24 24" fill="none"><polyline points="16 18 22 12 16 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><polyline points="8 6 2 12 8 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span> do vídeo</span>
                <span class="uv-step-arrow">→</span>
                <span class="uv-step">3. Copie o <strong>Código de Embed</strong></span>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="uv-footer">
            <span class="uv-footer-tip">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#94a3b8" stroke-width="2"/><path d="M12 16v-4M12 8h.01" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/></svg>
              Esta mensagem não será exibida novamente
            </span>
            <button class="uv-btn" @click="closeUpdateModal">
              Entendi, vou atualizar!
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" style="margin-left:6px">
                <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>

        </div>
      </div>
    </transition>

    <!-- ══════════════════════════════════════════
         PAINEL DE CONTROLE DO DASHBOARD
    ══════════════════════════════════════════ -->
    <div class="dk-control-panel">

      <!-- Filtros em uma unica linha -->
      <div class="dkcp-filters-row">

        <!-- Segmento de modo -->
        <div class="dkcp-mode-segment">
          <button
            class="dkcp-seg-btn"
            :class="{ 'dkcp-seg-btn--active': mode === 'chat' }"
            @click="setMode('chat')"
          >
            <i class="el-icon-chat-dot-round" />
            Chat
          </button>
          <button
            class="dkcp-seg-btn"
            :class="{ 'dkcp-seg-btn--active': mode === 'video' }"
            @click="setMode('video')"
          >
            <i class="el-icon-video-play" />
            Video
          </button>
        </div>

        <!-- Seletor de fonte -->
        <div class="dkcp-field">
          <el-select
            v-if="mode === 'chat'"
            v-model="selectedValue"
            placeholder="Todos os chats"
            class="dkcp-select"
            clearable
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
          <el-select
            v-else
            v-model="selectedVsl"
            placeholder="Todos os vídeos"
            class="dkcp-select"
            clearable
          >
            <el-option
              v-for="item in vslOptions"
              :key="item.id"
              :label="item.vsl_name"
              :value="item.id"
            />
          </el-select>
        </div>

        <!-- Seletor de periodo -->
        <div class="dkcp-field dkcp-field--period">
          <div class="dkcp-period-pills">
            <button
              v-for="opt in optionsData"
              :key="opt.value"
              class="dkcp-pill"
              :class="{ 'dkcp-pill--active': value === opt.value }"
              @click="value = opt.value"
            >
              {{ opt.label }}
            </button>
          </div>
        </div>
      </div>

      <!-- Linha 3: Intervalo personalizado (só quando selecionado) -->
      <transition name="dkcp-slide">
        <div v-if="value === 'intervalo'" class="dkcp-daterange-row">
          <i class="el-icon-date dkcp-date-icon" />
          <el-input
            v-model="endDate"
            type="date"
            size="small"
            class="dkcp-date-input"
            placeholder="Data inicial"
          />
          <span class="dkcp-date-arrow">→</span>
          <el-input
            v-model="startDate"
            type="date"
            size="small"
            class="dkcp-date-input"
            placeholder="Data final"
          />
          <button class="dkcp-apply-btn" @click="getFilterDataIntervalo">
            <i class="el-icon-search" />
            Aplicar filtro
          </button>
        </div>
      </transition>

    </div>

    <!-- ── KPI CARDS ── -->
    <div class="dk-kpi-grid">
      <div class="dk-kpi" id="views">
        <div class="dk-kpi__icon-wrap dk-kpi__icon--teal">
          <i class="el-icon-view" />
        </div>
        <div class="dk-kpi__body">
          <span class="dk-kpi__label">Visualizações</span>
          <span class="dk-kpi__value">{{ kpi.views }}</span>
        </div>
      </div>

      <div class="dk-kpi" id="paly">
        <div class="dk-kpi__icon-wrap dk-kpi__icon--orange">
          <i class="el-icon-video-play" />
        </div>
        <div class="dk-kpi__body">
          <span class="dk-kpi__label">{{ mode === 'chat' ? 'Iniciado' : 'Plays' }}</span>
          <span class="dk-kpi__value">{{ kpi.started }}</span>
        </div>
      </div>

      <div class="dk-kpi" id="PlayRate">
        <div class="dk-kpi__icon-wrap dk-kpi__icon--blue">
          <i class="el-icon-s-data" />
        </div>
        <div class="dk-kpi__body">
          <span class="dk-kpi__label">{{ mode === 'chat' ? 'Finalizado' : 'Play Rate' }}</span>
          <span class="dk-kpi__value">{{ kpi.finished }}</span>
        </div>
      </div>

      <div class="dk-kpi" id="Engajamento">
        <div class="dk-kpi__icon-wrap dk-kpi__icon--pink">
          <i class="el-icon-s-marketing" />
        </div>
        <div class="dk-kpi__body">
          <span class="dk-kpi__label">Engajamento</span>
          <span class="dk-kpi__value">{{ kpi.engajamento }}</span>
        </div>
      </div>
    </div>

    <!-- ── FUNIL ── -->
    <div class="dk-funnel-section">
      <FunnelGraph
        :objs-funnel-geral="objsFunnelGeral"
        :funnel-labels="funnelLabels"
      />
    </div>

  </div>
</template>

<script>
import { useApi } from '@/composables/useApi'
import { AnalyticService } from '@/services/Analytic'
import FunnelGraph from '@/views/App/Chat/GraficoChat.vue'
import {
  BCard, BRow, BCol, BCardTitle, BCardText,
} from 'bootstrap-vue'

const api = useApi()
const analyticService = new AnalyticService()

function fmtDate(d) {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${dd}`
}

export default {
  components: {
    BCard, BRow, BCol, BCardTitle, BCardText, FunnelGraph,
  },
  data() {
    return {
      mode: 'video',

      // ── chat data ──
      visualizacao: 0,
      iniciado: 0,
      finalizado: 0,
      engajamento: 0,
      options: [],

      // ── video data ──
      vslOptions: [],
      selectedVsl: '',
      vViews: 0,
      vPlays: 0,
      vPlayRate: '0',
      vEngajamento: '0',

      // funil (shared)
      objsFunnelGeral: [0, 0, 0, 0],

      // shared state
      dadosPagamento: [],
      selectedValue: '',
      startDate: null,
      endDate: null,
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',

      optionsData: [
        { value: 'hoje',        label: 'Hoje' },
        { value: 'ontem',       label: 'Ontem' },
        { value: 'sete_dias',   label: '7 dias' },
        { value: 'trinta_dias', label: '30 dias' },
        { value: 'full_dias',   label: 'Tudo' },
        { value: 'intervalo',   label: 'Personalizado' },
      ],
      value: 'sete_dias',
      showUpdateModal: false,
    }
  },

  computed: {
    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
    funnelLabels() {
      if (this.mode === 'chat') {
        return ['Visualização', 'Iniciado', 'Finalizado', 'Engajamento']
      }
      return ['Visualizações', 'Plays', 'Play Rate', 'Engajamento']
    },
    kpi() {
      if (this.mode === 'chat') {
        return {
          views:      this.visualizacao,
          started:    this.iniciado,
          finished:   this.finalizado,
          engajamento: this.engajamento,
        }
      }
      return {
        views:      this.vViews,
        started:    this.vPlays,
        finished:   `${this.vPlayRate}%`,
        engajamento: `${this.vEngajamento}%`,
      }
    },
  },

  watch: {
    value(newValue) {
      if (newValue && newValue !== 'intervalo') {
        this.getDataFilter(newValue)
      }
    },
    selectedValue(newValue) {
      if (this.mode === 'chat') this.getDataFilter(this.value)
    },
    selectedVsl(newValue) {
      if (this.mode === 'video') this.fetchVideoData()
    },
  },

  mounted() {
    this.checkUpdateNotice()
    this.buscarDados()
    this.getChats()
    this.getVsls()
    this.getDataFilter(this.value)
  },

  methods: {
    checkUpdateNotice() {
      const seen = localStorage.getItem('vslbooster_v2_update_notice')
      if (!seen) this.showUpdateModal = true
    },
    closeUpdateModal() {
      localStorage.setItem('vslbooster_v2_update_notice', '1')
      this.showUpdateModal = false
    },

    setMode(m) {
      this.mode = m
      this.selectedValue = ''
      this.selectedVsl = ''
      this.getDataFilter(this.value)
    },

    buscarDados() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/pagamento/${this.getUserData.id}`)
        .then(r => r.json())
        .then(r => { this.dadosPagamento = r[0] })
        .catch(console.error)
    },

    async getChats() {
      const r = await api.get(`chat/${this.getUserData.id}`)
      this.options = r.data
    },

    async getVsls() {
      const r = await api.get(`vslUserId/${this.getUserData.id}`)
      const all = r.data || []
      this.vslOptions = all.filter(v => v.vsl_ativo === 1 || v.vsl_ativo === undefined)
    },

    getDataFilter(TypeDate) {
      if (this.mode === 'chat') {
        this.getChatData(TypeDate)
      } else {
        this.fetchVideoData()
      }
    },

    // ─────────────────────────────────
    //  VIDEO mode
    // ─────────────────────────────────
    async fetchVideoData() {
      const p = this.buildDateParams(this.value)
      let obj
      try {
        if (!this.selectedVsl) {
          obj = await analyticService.getDashBoardGrl(this.getUserData.id, p)
        } else {
          obj = await analyticService.getByIdVslObjts(this.selectedVsl, p)
        }
        this.processVideoData(obj)
      } catch (e) {
        console.error('video data error', e)
      }
    },

    processVideoData(obj) {
      if (!obj || !Array.isArray(obj) || obj.length === 0) {
        this.vViews = 0; this.vPlays = 0; this.vPlayRate = '0'; this.vEngajamento = '0'
        this.objsFunnelGeral = [0, 0, 0, 0]
        return
      }
      const n = obj.length || 1
      this.vViews = obj.reduce((acc, v) => acc + (v.qtde_load || 0), 0)
      this.vPlays = obj.reduce((acc, v) => acc + (v.qtde_play || 0), 0)
      this.vPlayRate = (obj.reduce((acc, v) => acc + (v.playRate || 0), 0) / n).toFixed(2)
      this.vEngajamento = (obj.reduce((acc, v) => acc + (v.engajamento || 0), 0) / n).toFixed(2)
      this.objsFunnelGeral = [
        this.vViews,
        this.vPlays,
        parseFloat(this.vPlayRate),
        parseFloat(this.vEngajamento),
      ]
    },

    buildDateParams(TypeDate) {
      const d = new Date()
      if (!TypeDate || TypeDate === 'sete_dias') {
        const end = new Date(d); end.setDate(end.getDate() - 7)
        return { start_date: fmtDate(d), end_date: fmtDate(end) }
      }
      if (TypeDate === 'hoje') return { start_date: fmtDate(d), end_date: fmtDate(d) }
      if (TypeDate === 'ontem') {
        const y = new Date(d); y.setDate(y.getDate() - 1)
        return { start_date: fmtDate(y), end_date: fmtDate(y) }
      }
      if (TypeDate === 'trinta_dias') {
        const end = new Date(d); end.setDate(end.getDate() - 30)
        return { start_date: fmtDate(d), end_date: fmtDate(end) }
      }
      if (TypeDate === 'full_dias') return {}
      if (TypeDate === 'intervalo') return { start_date: this.startDate, end_date: this.endDate }
      return {}
    },

    // ─────────────────────────────────
    //  CHAT mode
    // ─────────────────────────────────
    getChatData(TypeDate) {
      if (!TypeDate || TypeDate === 'sete_dias') return this.getFilterData7days()
      if (TypeDate === 'hoje')        return this.getFilterDateHoje()
      if (TypeDate === 'ontem')       return this.getFilterDataOntem()
      if (TypeDate === 'trinta_dias') return this.getFilterData30days()
      if (TypeDate === 'full_dias')   return this.getFilterDataTempoTodo()
    },

    setChatKpis(data) {
      const d = (data && data[0]) || {}
      const v  = d.total_views    || 0
      const i  = d.total_started  || 0
      const f  = d.total_finished || 0
      this.visualizacao = v
      this.iniciado     = i
      this.finalizado   = f
      this.engajamento  = i > 0 ? `${(f / i * 100).toFixed(2)}%` : '0%'
      this.objsFunnelGeral = [v, i, f, i > 0 ? parseFloat((f / i).toFixed(2)) : 0]
    },

    async getFilterDateHoje() {
      const r = !this.selectedValue
        ? await api.get(`analytics/today/${this.getUserData.id}`)
        : await api.get(`chathoje/${this.selectedValue}`)
      this.setChatKpis(r.data)
    },

    async getFilterDataOntem() {
      const r = !this.selectedValue
        ? await api.get(`analytics/yesterday/${this.getUserData.id}`)
        : await api.get(`chatontem/${this.selectedValue}`)
      this.setChatKpis(r.data)
    },

    async getFilterData7days() {
      const r = !this.selectedValue
        ? await api.get(`analytics/lastweek/${this.getUserData.id}`)
        : await api.get(`chat7dias/${this.selectedValue}`)
      this.setChatKpis(r.data)
    },

    async getFilterData30days() {
      const r = !this.selectedValue
        ? await api.get(`analytics/lastmonth/${this.getUserData.id}`)
        : await api.get(`chatultimomes/${this.selectedValue}`)
      this.setChatKpis(r.data)
    },

    async getFilterDataTempoTodo() {
      const r = !this.selectedValue
        ? await api.get(`analytics/all/${this.getUserData.id}`)
        : await api.get(`chatTodos/${this.selectedValue}`)
      this.setChatKpis(r.data)
    },

    async getFilterDataIntervalo() {
      if (this.mode === 'video') {
        await this.fetchVideoData()
        return
      }
      const r = !this.selectedValue
        ? await api.get(`get/booster/getViewerDashBoardChat/${this.getUserData.id}?startDate=${this.endDate}&endDate=${this.startDate}`)
        : await api.get(`get/booster/getViewerDashBoardByChat/${this.selectedValue}?startDate=${this.endDate}&endDate=${this.startDate}`)
      this.setChatKpis(r.data)
    },
  },
}
</script>

<style>
/* ══════════════════════════════════════════════════════
   DK CONTROL PANEL — Painel de controle do dashboard
══════════════════════════════════════════════════════ */

.dk-control-panel {
  background: #fff;
  background: var(--dk-bg-card, #ffffff);
  border: 1px solid #DDE3EA;
  border: 1px solid var(--dk-border, #DDE3EA);
  border-radius: 14px;
  margin-bottom: 20px;
  overflow: visible;
  box-shadow: 0 2px 12px rgba(13, 51, 73, 0.06);
  box-shadow: var(--dk-shadow-md, 0 2px 12px rgba(13, 51, 73, 0.06));
  padding: 12px 16px;
}
.dark-layout .dk-control-panel {
  background: #1a2840;
  border-color: rgba(255,255,255,0.1);
}

/* Segmented control de modo */
.dkcp-mode-segment {
  display: inline-flex;
  background: var(--dk-bg-segment, #F0F3F7);
  border-radius: 10px;
  padding: 4px;
  gap: 2px;
}

.dkcp-seg-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 18px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: var(--dk-text-secondary, #6e7a8a);
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.dkcp-seg-btn:hover {
  color: var(--dk-text-primary, #0D3349);
  background: rgba(13, 51, 73, 0.07);
}

.dkcp-seg-btn--active {
  background: #E86A10;
  color: #ffffff;
  box-shadow: 0 3px 10px rgba(232, 106, 16, 0.4);
}

.dkcp-seg-btn--active:hover {
  background: #E86A10;
  color: #fff;
}

.dkcp-seg-icon {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  font-size: 12px;
}

.dkcp-seg-btn:not(.dkcp-seg-btn--active) .dkcp-seg-icon {
  background: rgba(13, 51, 73, 0.08);
  color: var(--dk-text-primary, #0D3349);
}

/* Badge do plano */
.dkcp-plan-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #E86A10 0%, #F5B935 100%);
  color: #ffffff;
  border-radius: 20px;
  padding: 5px 14px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.3px;
  box-shadow: 0 3px 10px rgba(232, 106, 16, 0.35);
  white-space: nowrap;
  text-transform: uppercase;
}

.dkcp-plan-badge i {
  font-size: 13px;
}

/* ── Divider ── */
.dkcp-divider {
  height: 1px;
  background: var(--dk-border, #E4EAF0);
  margin: 0 20px;
}

/* ── Filtros em uma linha ── */
.dkcp-filters-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.dkcp-field {
  display: flex;
  flex-direction: column;
  gap: 0;
  flex-shrink: 0;
}

.dkcp-field--period {
  flex: 1;
  min-width: 0;
}

.dkcp-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--dk-text-muted, #8a96a3);
  margin: 0;
}

.dkcp-label i {
  font-size: 11px;
  color: var(--dk-text-primary, #0D3349);
}

.dkcp-select {
  min-width: 190px;
}

/* Separador vertical */
.dkcp-vsep {
  width: 1px;
  height: 44px;
  background: var(--dk-border, #E4EAF0);
  margin: 0 20px;
  align-self: flex-end;
  flex-shrink: 0;
}

/* ── Pills de período ── */
.dkcp-period-pills {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.dkcp-pill {
  padding: 7px 14px;
  border-radius: 8px;
  border: 1.5px solid var(--dk-border-input, #DDE3EA);
  background: var(--dk-bg-input, #fff);
  color: var(--dk-text-secondary, #5e6b78);
  font-size: 0.80rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.17s ease;
  white-space: nowrap;
  line-height: 1;
}

.dkcp-pill:hover {
  border-color: var(--dk-text-secondary, #0D3349);
  color: var(--dk-text-primary, #0D3349);
  background: rgba(232, 106, 16, 0.05);
}

.dkcp-pill--active {
  background: #E86A10;
  border-color: #E86A10;
  color: #ffffff;
  box-shadow: 0 3px 8px rgba(232, 106, 16, 0.35);
}

.dkcp-pill--active:hover {
  background: #E86A10;
  color: #fff;
}

/* ── Linha 3: Intervalo personalizado ── */
.dkcp-daterange-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px 16px;
  flex-wrap: wrap;
}

.dkcp-date-icon {
  color: var(--dk-text-primary, #0D3349);
  font-size: 16px;
  flex-shrink: 0;
}

.dkcp-date-input {
  width: 150px;
}

.dkcp-date-arrow {
  color: var(--dk-text-muted, #8a96a3);
  font-size: 16px;
  flex-shrink: 0;
}

.dkcp-apply-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 18px;
  border-radius: 8px;
  border: none;
  background: #E86A10;
  color: #ffffff;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.18s ease;
  box-shadow: 0 3px 10px rgba(232, 106, 16, 0.3);
}

.dkcp-apply-btn:hover {
  background: #d05e0e;
  box-shadow: 0 4px 14px rgba(232, 106, 16, 0.45);
  transform: translateY(-1px);
}

/* ── Transição slide do intervalo ── */
.dkcp-slide-enter-active,
.dkcp-slide-leave-active {
  transition: all 0.22s ease;
  overflow: hidden;
}
.dkcp-slide-enter,
.dkcp-slide-leave-to {
  opacity: 0;
  max-height: 0;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.dkcp-slide-enter-to,
.dkcp-slide-leave {
  opacity: 1;
  max-height: 80px;
}

/* ── KPI GRID ── */
.dk-kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin: 16px 0;
}

.dk-kpi {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  background: #fff;
  background: var(--dk-bg-card, #fff);
  border: 1px solid #edf1f4;
  border: 1px solid var(--dk-border, #edf1f4);
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
  box-shadow: var(--dk-shadow-sm, 0 1px 4px rgba(0,0,0,0.04));
  transition: all 0.2s;
}
.dark-layout .dk-kpi {
  background: #1a2840;
  border-color: rgba(255,255,255,0.1);
}
.dark-layout .dk-kpi__label { color: #a0b4c8; }
.dark-layout .dk-kpi__value { color: #e8edf4; }
.dk-kpi:hover {
  box-shadow: var(--dk-shadow-md);
  transform: translateY(-2px);
}

.dk-kpi__icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 22px;
}
.dk-kpi__icon--teal   { background: rgba(24,217,173,0.12); color: #18d9ad; }
.dk-kpi__icon--orange { background: rgba(232,106,16,0.12); color: #E86A10; }
.dk-kpi__icon--blue   { background: rgba(49,143,235,0.12); color: #318feb; }
.dk-kpi__icon--pink   { background: rgba(245,185,53,0.12); color: #F5B935; }

.dk-kpi__body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.dk-kpi__label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--dk-text-muted, #8a94a6);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.dk-kpi__value {
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--dk-text-primary, #0D3349);
  line-height: 1;
  letter-spacing: -0.5px;
}

/* ── Funnel section ── */
.dk-funnel-section {
  margin-top: 4px;
  background: #fff;
  background: var(--dk-bg-card, #fff);
  border: 1px solid #edf1f4;
  border: 1px solid var(--dk-border, #edf1f4);
  border-radius: 14px;
  padding: 20px;
  min-height: 300px;
}
.dark-layout .dk-funnel-section {
  background: #1a2840;
  border-color: rgba(255,255,255,0.1);
}

@media (max-width: 768px) {
  .dk-kpi-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 480px) {
  .dk-kpi-grid { grid-template-columns: 1fr; }
}

/* ══════════════════════════════════════════
   MODAL NOVA VERSÃO (UV)
══════════════════════════════════════════ */
.uv-overlay {
  position: fixed;
  inset: 0;
  background: rgba(13, 27, 46, 0.75);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
}

.uv-card {
  background: var(--dk-bg-card, #fff);
  border-radius: 20px;
  width: 100%;
  max-width: 560px;
  box-shadow: 0 30px 80px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.05);
  overflow: hidden;
}

.uv-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 20px;
  background: linear-gradient(135deg, #0D1B2E 0%, #0D3349 100%);
}

.uv-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.uv-rocket {
  font-size: 36px;
  line-height: 1;
  filter: drop-shadow(0 2px 8px rgba(232,106,16,0.5));
}

.uv-tag {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: #F5B935;
  margin-bottom: 4px;
}

.uv-title {
  font-size: 20px;
  font-weight: 800;
  color: #fff;
  margin: 0;
  letter-spacing: -0.3px;
}

.uv-close {
  background: rgba(255,255,255,0.1);
  border: none;
  border-radius: 8px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255,255,255,0.7);
  cursor: pointer;
  transition: all 0.15s;
  flex-shrink: 0;
}
.uv-close:hover {
  background: rgba(255,255,255,0.2);
  color: #fff;
}

.uv-body {
  padding: 24px;
}

.uv-intro {
  font-size: 14px;
  color: var(--dk-text-secondary, #475569);
  margin: 0 0 16px;
  line-height: 1.5;
}

.uv-changes {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.uv-change-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13.5px;
  color: var(--dk-text-secondary, #334155);
  line-height: 1.4;
}

.uv-change-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.uv-change-icon--blue   { background: rgba(59,130,246,0.1); color: #3B82F6; }
.uv-change-icon--green  { background: rgba(16,185,129,0.1); color: #10B981; }
.uv-change-icon--purple { background: rgba(139,92,246,0.1); color: #8B5CF6; }
.uv-change-icon--orange { background: rgba(232,106,16,0.1); color: #E86A10; }

.uv-alert {
  display: flex;
  gap: 12px;
  background: #FFF7ED;
  border: 1.5px solid #FDBA74;
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 16px;
}

.uv-alert-icon {
  flex-shrink: 0;
  margin-top: 1px;
}

.uv-alert-text {
  font-size: 13px;
  color: #92400E;
  line-height: 1.5;
}
.uv-alert-text strong { display: block; margin-bottom: 4px; color: #78350F; font-size: 13.5px; }
.uv-alert-text p { margin: 0; }

.uv-snippet-wrap {
  background: var(--dk-bg-inset, #F8FAFC);
  border: 1px solid var(--dk-border, #E2E8F0);
  border-radius: 10px;
  padding: 12px 16px;
}

.uv-snippet-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: var(--dk-text-muted, #64748B);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
}

.uv-snippet-steps {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.uv-step {
  font-size: 13px;
  color: var(--dk-text-secondary, #334155);
  background: var(--dk-bg-card, #fff);
  border: 1px solid var(--dk-border, #E2E8F0);
  border-radius: 6px;
  padding: 4px 10px;
}

.uv-step-arrow {
  color: var(--dk-text-muted, #94A3B8);
  font-size: 13px;
  font-weight: 600;
}

.uv-code-btn-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--dk-bg-inset, #F4F6F9);
  border: 1px solid var(--dk-border, #DDE3EA);
  border-radius: 5px;
  padding: 1px 6px;
  color: var(--dk-text-primary, #0D3349);
  vertical-align: middle;
  margin: 0 2px;
  line-height: 1;
}

.uv-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px 24px;
  border-top: 1px solid var(--dk-border-light, #F1F5F9);
}

.uv-footer-tip {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: var(--dk-text-muted, #94A3B8);
}

.uv-btn {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #E86A10 0%, #F5B935 100%);
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 11px 20px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 14px rgba(232,106,16,0.35);
  white-space: nowrap;
}
.uv-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(232,106,16,0.45);
}

/* Transição */
.uv-fade-enter-active,
.uv-fade-leave-active { transition: opacity 0.25s ease; }
.uv-fade-enter, .uv-fade-leave-to { opacity: 0; }
.uv-fade-enter .uv-card, .uv-fade-leave-to .uv-card { transform: scale(0.96); }

@media (max-width: 600px) {
  .uv-footer { flex-direction: column; gap: 12px; align-items: stretch; }
  .uv-btn { justify-content: center; }
  .uv-footer-tip { justify-content: center; }
}
</style>
